<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © Wanar · DefarSoft.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Conçu et développé par DefarSoft
                </div>
            </div>
        </div>
    </div>
</footer>